import * as React from "react"
import { graphql, Link, PageProps } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { IndexPageDataQuery } from "../../graphql/graphql-types"

const IndexPage: React.FC<PageProps<IndexPageDataQuery>> = ({ data, path }) => (
  <Layout>
    <SEO title="Home"/>
    <h1>Hi people</h1>
    <p>Welcome to your new Gatsby site.</p>
    <p>Now go build something great.</p>
    <Link to="/page-2/">Go to page 2</Link> <br/>
    <p>You're currently on the page "{path}" which was built on {data.site.buildTime}.</p>
  </Layout>
)

export default IndexPage

export const query = graphql`
  query IndexPageData {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
